import React, { useCallback, useEffect, useState } from 'react';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';

import CategoryCreateWindow from '../components/organisms/Maintenance/CreateWindow/CategoryCreateWindow';

import { ConfirmationDialog } from '../components/organisms/ConfirmationDialog';
import {
  CategoryType,
  MaintenanceCategoryTable
} from '../components/organisms/Maintenance/Table/MaintenanceCategoryTable';
import { CategpryBrowseWindow } from '../components/organisms/Maintenance/BrowseWindow/CategoryBrowseWindow';
import CategoryEditWindow from '../components/organisms/Maintenance/EditWindow/CategoryEditWindow';
import {
  MaintenanceHeader,
  selectTabEnum
} from '../components/organisms/Maintenance/MaintenanceHeader';
import { MaintenanceTitle } from '../components/organisms/Maintenance/MaintenanceTitle';
import CategorySearchBox from '../components/organisms/Maintenance/SearchWindow/CategorySearchBox';
import { DeleteCategoriesApi } from '../apis/DeleteMaintenance.api';
import { GetCategoryApi } from '../apis/GetMaintenance.api';
import { chooseDataStateType } from '../components/molecules/MaintenanceModalDispLabels';
import CategoryChangeTypeButtons from '../components/molecules/CategoryChangeTypeButtons';
import { CategorySendMessageType } from '../components/constants/MaintenanceConstants';

export type CategoryStateType = {
  type: 'category';
  category: CategoryType;
};

export type CategoryArrayStateType = {
  type: 'category';
  category: CategoryType[] | undefined;
};

export interface CategorySearchCondition {
  sort: { key: string; sortType: boolean };
  categoryName: string;
  type: string;
  dateCreatedFrom: string;
  dateCreatedTo: string;
  dateUpdatedFrom: string;
  dateUpdatedTo: string;
}

export const CategoryMaintenance: React.FC = () => {
  const stateUpdate = (data: chooseDataStateType) => {
    if (data.type === 'category') {
      setChooseData(data.category);
    }
  };
  const DeleteApi = async () => {
    if (chooseData?.id !== undefined) {
      const response = await DeleteCategoriesApi(chooseData.id);
      if (response.success) {
        setMaintenanceDatas(response.data as CategoryType[]);
        CreateOrUpdateStateSwitch();
      }
    }
  };

  const [chooseButton, setChooseButton] = useState(
    CategorySendMessageType.None
  );

  const MessageTypeChange = useCallback((type: string) => {
    setChooseButton(type);
  }, []);

  const [query, setQuery] = useState<CategorySearchCondition>({
    sort: { key: '', sortType: false },
    categoryName: '',
    type: '',
    dateCreatedFrom: '',
    dateCreatedTo: '',
    dateUpdatedFrom: '',
    dateUpdatedTo: ''
  });

  const [createOrUpdate, setCreateOrUpdate] = useState(false);

  const CreateOrUpdateStateSwitch = useCallback(() => {
    setQuery({
      sort: { key: '', sortType: false },
      categoryName: '',
      type: '',
      dateCreatedFrom: '',
      dateCreatedTo: '',
      dateUpdatedFrom: '',
      dateUpdatedTo: ''
    });
    setCreateOrUpdate(!createOrUpdate);
  }, [createOrUpdate]);

  const [searchSwitch, setSearchSwitch] = useState(false);

  const SearchStateSwitch = useCallback(() => {
    setSearchSwitch(!searchSwitch);
  }, [searchSwitch]);

  const {
    isOpen: isOpenCreate,
    onOpen: onOpenCreate,
    onClose: onCloseCreate
  } = useDisclosure();
  const {
    isOpen: isOpenBrowse,
    onOpen: onOpenBrowse,
    onClose: onCloseBrowse
  } = useDisclosure();
  const {
    isOpen: isOpenEdit,
    onOpen: onOpenEdit,
    onClose: onCloseEdit
  } = useDisclosure();
  const {
    isOpen: isOpenConfirm,
    onOpen: onToggle,
    onClose: onCloseConfirm
  } = useDisclosure();
  const [chooseData, setChooseData] = useState<CategoryType>();
  const [maintenanceDatas, setMaintenanceDatas] = useState<
    CategoryType[] | undefined
  >();

  const GetApi = async () => {
    const response = await GetCategoryApi();
    if (response.success) {
      setMaintenanceDatas(response.data as CategoryType[]);
    }
  };

  useEffect(() => {
    GetApi();
  }, []);

  return (
    <>
      <Flex direction='column' h='100vh'>
        <MaintenanceHeader selectTab={selectTabEnum.Category} />
        <MaintenanceTitle
          selectTab={selectTabEnum.Category}
          onOpen={onOpenCreate}
        />
        <Box
          position='relative'
          display='grid'
          gridTemplateRows='0.1fr 2fr 0.1fr'
          gridTemplateColumns='3fr 1fr'
          h='100%'
        >
          <CategoryChangeTypeButtons
            Query={query}
            setQuery={setQuery}
            setMaintenanceDatas={setMaintenanceDatas}
            createOrUpdate={createOrUpdate}
            chooseButton={chooseButton}
            MessageTypeChange={MessageTypeChange}
          />
          <MaintenanceCategoryTable
            CategoryDatas={maintenanceDatas}
            setMaintenanceDatas={setMaintenanceDatas}
            setChooseData={stateUpdate}
            onOpenBrowse={onOpenBrowse}
            onOpenEdit={onOpenEdit}
            onToggle={onToggle}
            Query={query}
            setQuery={setQuery}
            createOrUpdate={createOrUpdate}
            searchSwitch={searchSwitch}
            chooseButton={chooseButton}
          />

          <CategorySearchBox
            setMaintenanceDatas={setMaintenanceDatas}
            Query={query}
            setQuery={setQuery}
            createOrUpdate={createOrUpdate}
            SearchStateSwitch={SearchStateSwitch}
          />

          {isOpenCreate && (
            <CategoryCreateWindow
              isOpen={isOpenCreate}
              onClose={onCloseCreate}
              setMaintenanceDatas={setMaintenanceDatas}
              CreateOrUpdateStateSwitch={CreateOrUpdateStateSwitch}
            />
          )}

          {isOpenBrowse && (
            <CategpryBrowseWindow
              isOpen={isOpenBrowse}
              onClose={onCloseBrowse}
              BrowseData={chooseData}
            />
          )}

          {isOpenEdit && (
            <CategoryEditWindow
              isOpen={isOpenEdit}
              onClose={onCloseEdit}
              EditData={chooseData}
              setMaintenanceDatas={setMaintenanceDatas}
              CreateOrUpdateStateSwitch={CreateOrUpdateStateSwitch}
            />
          )}
          {isOpenConfirm && (
            <ConfirmationDialog
              isOpen={isOpenConfirm}
              onClose={onCloseConfirm}
              dispMessage={'本当に削除しますか？'}
              DeleteApi={DeleteApi}
            />
          )}
        </Box>
      </Flex>
    </>
  );
};
